import { jsx as _jsx } from "react/jsx-runtime";
import classNames from "classnames";
import dompurify from "isomorphic-dompurify";
import "./Button.scss";
const { sanitize } = dompurify;
const BUTTON_TYPE = {
    white: "button--white",
    black: "button--black",
    transparent: "button--transparent",
    "transparent-black": "button--transparentBlack",
    "transparent-black-thickborder": "button--transparentBlack--thickBorder",
};
const BUTTON_FONT_WEIGHT = {
    default: "button--default",
    bold: "button--bold",
};
/**
 * @deprecated use Button from @jti/ui instead
 */
export const Button = ({ dataTestId = "", url = "", children, buttonType = "transparent", className = "", weight = "default", onClick, hidden, }) => {
    const currentClassName = classNames(className, {
        button: true,
        [BUTTON_TYPE[buttonType]]: true,
        [BUTTON_FONT_WEIGHT[weight]]: true,
    });
    const handleClick = ($event) => {
        if (onClick) {
            onClick($event);
        }
    };
    if (hidden) {
        return null;
    }
    if (!url || url.length === 0) {
        return (_jsx("button", { "data-testid": dataTestId, className: currentClassName, onClick: handleClick, dangerouslySetInnerHTML: { __html: sanitize(children) } }));
    }
    return (_jsx("a", { "data-testid": dataTestId, href: url, className: currentClassName, onClick: handleClick, dangerouslySetInnerHTML: { __html: sanitize(children) } }));
};
//# sourceMappingURL=Button.js.map